import { cx } from "@jugl-web/utils";
import { TableGridClasses, TableGridVariant } from "./types";

export const tableGridClassesByVariant: Record<
  TableGridVariant,
  TableGridClasses
> = {
  grid: {
    wrapper: "",
    headerCell: cx(
      `relative bg-white px-4 py-3 text-xs text-dark-700 font-secondary flex items-center transition-colors`,
      `border border-solid border-l-0 border-t-0 border-b-0 border-r-[#EEF2F5]`,
      `data-[table-column-reversed="0"]:border-r-0`
    ),
    bodyCell: cx(
      `relative bg-white transition-colors duration-50 px-4 py-3 text-dark-800 font-secondary text-sm`,
      `border-0 border-t border-solid border-[#EEF2F5] border-r`,
      `data-[row-hovered="true"]:bg-grey-100`,
      `data-[table-column-reversed="0"]:border-r-0`,
      `data-[table-row-reversed="0"]:data-[table-column="0"]:rounded-bl-xl`,
      `data-[table-row-reversed="0"]:data-[table-column-reversed="0"]:rounded-br-xl`
    ),
  },
  row: {
    wrapper: "bg-white",
    headerCell:
      "z-10 flex h-20 items-center self-start whitespace-nowrap border-x-0 border-b-[16px] border-t-[16px] border-solid border-gray-50 bg-white px-2 text-xs font-[500] text-[#93949A]",
    bodyCell: "bg-white px-2 py-4",
  },
};
